import React, { Component } from 'react';
import { Link } from "react-router-dom";

import { Study } from './Study'

import './App.css';

const GridItem = props => {
  const style = {
    "backgroundImage": "url(/studies/" + props.study.key + "/" + props.study.featuredImage + ")"
  }

  var className = "study-item-img";
  if (props.study.key === props.selectedKey) {
    className += " selected"
  }
  return <Link to={`/study/${props.study.key}?show=true`}>
          <div className={"study-item"} id={props.study.key} onMouseEnter={props.mouseEnter}>
            <div className={className} style={style}></div>
            <p className={"info emphasis"}>{props.study.title}</p>
            <p className={"info"}>{`${props.study.tag}`}</p>
          </div>
        </Link>
}

const isPresenting = props => {
  const queryParams = props.location.search
    .replace(/(^\?)/, "")
    .split("&")
    .map(
      function(n) {
        return (n = n.split("=")), (this[n[0]] = n[1]), this;
      }.bind({})
    )[0];

   if (queryParams["show"] !== undefined)
     return true;
   return false;
}

export class Home extends Component {

  constructor(props) {
    super(props);

    
    this.state = { currentStudy: null, presenting_study: isPresenting(this.props) }

    this.hoverStudy = this.hoverStudy.bind(this);
    this.setCurrentStudy = this.setCurrentStudy.bind(this);
  }

  componentDidMount() {
    this.setCurrentStudy(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.setCurrentStudy(nextProps)
  }

  hoverStudy(e) {
    this.props.history.push(`/study/${e.currentTarget.id}`);
  }

  setCurrentStudy(props) {

    if (props.studies.length === 0) {
      this.setState({ currentStudy: null, presenting_study: isPresenting(props) })
    } else if (props.match.params.key === undefined) {
      // find the first featured study and present that
      const featured_studies = props.studies.filter(s => s.featured)
      this.setState({ currentStudy: featured_studies[0], presenting_study: isPresenting(props) })
    } else {
      for (var i=0; i<props.studies.length; i++) {
        if (props.studies[i].key === props.match.params.key) {
          this.setState({ currentStudy: props.studies[i], presenting_study: isPresenting(props) })
          return;
        }
      }
      // we can't find a study with that key, default back to the first
      this.setState({ currentStudy: props.studies[0], presenting_study: isPresenting(props) })
    }
  }

  render() {

    const featured_studies = this.props.studies.filter(s => s.featured)
    const other_studies = this.props.studies.filter(s => !s.featured)

    var selectedKey = ''
    if (this.state.currentStudy !== null) {
      selectedKey = this.state.currentStudy.key
    }

    const gridItems = featured_studies.map((s) => {
        return <GridItem study={s} selectedKey={selectedKey} mouseEnter={this.hoverStudy}/>
      });

    const tlStyle = (this.state.presenting_study ? {} : { overflow: "hidden", position: "relative" })

    return (
      <div style={tlStyle}>
      <div className="root-container">
        <h1 className="emphasis info">Strata</h1>
        <h1 className="info">Architecture and Consulting</h1>
        <div className="hero-container">
          <h2 id="sub-info">Strata is a father and son operated architecture and consultancy firm based in Auckland, New Zealand.</h2>
          <br/>
          <h2 id="sub-info"><Link className="about-link" to="/about">Tell us about your next project</Link></h2>
          <div className="info-container">
            <div className="info-col">
              <p>Contact</p>
              <p>+649 827 7901</p>
              <p>office@strata-acrchitects.nz</p>
            </div>
            <div className="info-col">
              <p>Address</p>
              <p>478 Karangahape Road</p>
              <p>Auckland</p>
              <p>New Zealand 1010</p>
            </div>
          </div>

          <div className="studies-grid">
            {gridItems}
          </div>

        </div>
      </div>
      { this.state.presenting_study &&  <Link to={"/study/"+selectedKey}><div className="study-present-edge"></div></Link> }
      { this.props.studies.length !== 0 && <Study currentStudy={this.state.currentStudy} presenting={this.state.presenting_study} /> }
      </div>
    );
  }
}
